/**
 * Helper for getting a URL to a public asset.
 *
 * @param {string} name Name of the asset to get; use dot-separated name to access nested array entries
 * @returns {string|null} Public URL or null if the assets was not found
 * @author Philipp Seiler <sep@earlybird.at>
 */
const asset = (name: string): string | null => {
  const parts = name.split('.');
  let entry = Globals.assets;
  for (const part of parts) {
    if (part in entry) {
      entry = entry[part];
    }
  }
  return entry;
};
export default asset;
